import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const percent = (value, base) => (base > 0 ? ` (${Math.round((value / base) * 100)}%)` : '');

const Metric = ({ label, value, note }) => (
  <Box>
    <Typography variant="caption" color="text.secondary">
      {label}{note ? <Box component="span" sx={{ color: 'text.disabled' }}> · {note}</Box> : null}
    </Typography>
    <Typography variant="body2" sx={{ fontWeight: 600 }}>{value}</Typography>
  </Box>
);

/**
 * Aberturas e cliques de um envio que já saiu, e os cliques por botão do e-mail.
 * Percentuais sobre os e-mails enviados. Eventos de robôs já vêm descontados da API.
 * @param {{ edition: Object }} props - EDITION_SUMMARY
 */
function EditionEngagement({ edition }) {
  const sent = edition.sends?.sent || 0;
  if (sent === 0) return null;

  const opened = edition.opened || 0;
  const clicked = edition.clicked || 0;
  const byTarget = Array.isArray(edition.clicks_by_target) ? edition.clicks_by_target : [];

  return (
    <Box sx={{ mt: 2, pt: 2, borderTop: '1px solid #EEF1F6' }}>
      <Box sx={{ display: 'flex', gap: { xs: 2, md: 4 }, flexWrap: 'wrap' }}>
        <Metric label="Aberturas" note="aproximado" value={`${opened}${percent(opened, sent)}`} />
        <Metric label="Cliques" value={`${clicked}${percent(clicked, sent)}`} />
      </Box>

      {byTarget.length > 0 && (
        <Box sx={{ mt: 1.5 }}>
          <Typography variant="caption" color="text.secondary">Cliques por botão</Typography>
          <Box component="ul" sx={{ listStyle: 'none', p: 0, m: 0, mt: 0.5, display: 'grid', gap: 0.5 }}>
            {byTarget.map((item) => (
              <Box
                component="li"
                key={item.target}
                sx={{ display: 'flex', justifyContent: 'space-between', gap: 2, fontSize: '0.8125rem', maxWidth: 560 }}
                title={item.title && item.title !== item.label ? item.title : undefined}
              >
                <Typography variant="body2" component="span" sx={{ minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                  {item.label}
                </Typography>
                <Typography variant="body2" component="span" color="text.secondary" sx={{ whiteSpace: 'nowrap' }}>
                  <strong>{item.unique}</strong> {item.unique === 1 ? 'pessoa' : 'pessoas'} · {item.clicks} {item.clicks === 1 ? 'clique' : 'cliques'}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>
      )}
    </Box>
  );
}

export default EditionEngagement;
